import { Spin } from '../Generic';
import { Container, SpinWrapper, Badge } from './styles';

import { IconLock } from '@tabler/icons';

import propertyImg from '../../assets/images/image-example.png';
import userImg from '../../assets/images/user-avatar.png';

interface PropertyItemProps {
  location: string;
  name: string;
  ownerImageUrl?: string;
  ownerName?: string;
  imageUrl?: string;
  isPrivate?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

export default function PropertyItem({
  location,
  name,
  imageUrl,
  onClick,
  isLoading,
  isPrivate,
  ownerImageUrl,
  ownerName,
}: PropertyItemProps) {
  return (
    <Container isLoading={isLoading} onClick={onClick}>
      <div className="info">
        <p>{location}</p>
        <h3>
          {isPrivate && <IconLock size={20} color="var(--primary)" />}
          {name}
        </h3>

        {ownerName && (
          <Badge>
            <img src={ownerImageUrl || userImg} alt={ownerName} />
            <p>{ownerName}</p>
          </Badge>
        )}
      </div>

      <div className="image">
        <img
          src={imageUrl || propertyImg}
          alt="Imagem"
          className="property-image"
        />
      </div>

      {isLoading && (
        <SpinWrapper>
          <Spin />
        </SpinWrapper>
      )}
    </Container>
  );
}
